// extracted by mini-css-extract-plugin
export var st0 = "aku-module--st0--3wqQ7";
export var svgElem1 = "aku-module--svgElem1--3gxEP";
export var active = "aku-module--active--kBJNH";
export var svgElem2 = "aku-module--svgElem2--EJr2W";
export var svgElem3 = "aku-module--svgElem3--1f_Rp";
export var svgElem4 = "aku-module--svgElem4--1a10t";